<form #form="ngForm" [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="large" nbSpinnerMessage="Guardando customform...">
  <div class="row">
    <div class="col-md-12">
      <nb-card>
        <nb-card-header>
          <nav class="navbar navigation">
            <span><nb-icon icon="file-text-outline"></nb-icon> Datos del customform - {{customform.form_name}}</span>
            <button nbButton status="primary" (click)="back()"><nb-icon icon="arrow-back"></nb-icon>
        </button>

          </nav>

        </nb-card-header>

        <nb-card-body>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="nombre" class="label">Nombre</label>
                <input type="text" nbInput fullWidth id="nombre" name="nombre" [(ngModel)]="customform.form_name" #nombre="ngModel" pattern=".{2,}" [status]="nombre.dirty ? (nombre.invalid  ? 'danger' : 'success') : ''" [required]="true" [attr.aria-invalid]="nombre.invalid && nombre.touched ? true : null"
                />
                <ng-container *ngIf="nombre.invalid && nombre.touched">
                  <p class="error-message" *ngIf="nombre.errors?.required">
                    El nombre del customform es obligatorio!
                  </p>
                  <p class="error-message" *ngIf="nombre.errors?.pattern">
                    El nombre del customform es obligatorio!
                  </p>
                </ng-container>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="category" class="label">Módulo</label><br/>
                <nb-select [required]="true" #tipo="ngModel" placeholder="Seleccione Módulo del formulario" fullWidth name="role" [(ngModel)]="customform.module_name">
                  <nb-option [value]="item.value" *ngFor="let item of customformOptions">{{item.name}}</nb-option>
                </nb-select>
                <ng-container *ngIf="tipo.invalid && tipo.touched">
                  <p class="error-message" *ngIf="nombre.errors?.required">
                    Debe seleccionar un tipo de custom form!
                  </p>

                </ng-container>
              </div>
            </div>
          </div>





          <div class="row">
            <div class="col-sm-12">
              <ng2-smart-table [settings]="fieldssettings" [source]="source" (createConfirm)="confirmarFila($event)" (editConfirm)="confirmarEdFila($event)">
              </ng2-smart-table>
            </div>

          </div>
          <div class="row">
            <div class="col-sm-12">
              <label class="label">Importar / Exportar campos del Custom Form</label>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <button nbButton status="primary" (click)="exportarCampos()">Exportar Campos</button>
            </div>
            <div class="col-sm-6">
              <div class="form-group">

                <input type="file" nbInput fullWidth id="campos" name="Campos" (change)="actualizarArchivo($event.target.files)" />
              </div>
            </div>
            <div class="col-sm-3">
              <button nbButton status="primary" *ngIf="archivoCampos" (click)="importarCampos()">Importar Campos</button>
            </div>
          </div>

          <h6 class="mt-5">Grupos de dependencias</h6>
          <ng2-smart-table [settings]="dependenciessettings" [source]="sourceDependencies" (createConfirm)="confirmarDependencia($event)" (editConfirm)="confirmarDependencia($event)">
          </ng2-smart-table>

          <h6 class="mt-5">Eventos</h6>
          <ng2-smart-table class="attributes-table" [settings]="eventssettings" [source]="sourceEvents"  (createConfirm)="confirmarFilaEvents($event)" (editConfirm)="confirmarEdFilaEvents($event)">
          </ng2-smart-table>

        </nb-card-body>
      </nb-card>
    </div>



  </div>
  <div class="row">
    <div class="col-md-12">
      <button nbButton fullWidth status="primary" [disabled]="!form.valid" (click)="guardar()"><nb-icon icon="save"></nb-icon>Guardar</button>
    </div>

  </div>
</form>
